/* mm-header — sticky, announcement dismiss, mega menu rail switching, dropdowns, mobile drawer (drawer in Task 10) */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ---- Announcement dismiss (persisted) ----
  function initAnnounce() {
    document.querySelectorAll('[data-mm-announce]').forEach(function (el) {
      var textEl = el.querySelector('.mm-announce__text');
      if (!textEl) return;
      var key = 'mm-announce-dismissed:' + textEl.textContent;
      try { if (localStorage.getItem(key) === '1') { el.hidden = true; } } catch (e) {}
      var btn = el.querySelector('[data-mm-announce-close]');
      if (btn) btn.addEventListener('click', function () {
        el.hidden = true;
        try { localStorage.setItem(key, '1'); } catch (e) {}
      });
    });
  }

  // ---- Sticky shadow ----
  function initSticky() {
    var header = document.querySelector('[data-mm-header]');
    if (!header) return;
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // ---- Simple dropdowns (e.g. Support) ----
  function initDropdowns() {
    document.querySelectorAll('[data-mm-drop]').forEach(function (item) {
      var trigger = item.querySelector('[data-mm-drop-trigger]');
      var close = function () { item.classList.remove('is-open'); if (trigger) trigger.setAttribute('aria-expanded', 'false'); };
      var open = function () { item.classList.add('is-open'); if (trigger) trigger.setAttribute('aria-expanded', 'true'); };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      if (trigger) trigger.addEventListener('focus', open);
      item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
      item.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); if (trigger) trigger.focus(); } });
    });
  }

  // ---- Mega menu: open/close + rail switching with hover-intent ----
  function initMega() {
    var item = document.querySelector('[data-mm-mega-item]');
    if (!item) return;
    var trigger = item.querySelector('[data-mm-mega-trigger]');
    var mega = item.querySelector('[data-mm-megamenu]');
    if (!mega) return;

    var openTimer, closeTimer, railTimer;

    function open() { clearTimeout(closeTimer); item.classList.add('is-open'); if (trigger) trigger.setAttribute('aria-expanded', 'true'); }
    function close() { item.classList.remove('is-open'); if (trigger) trigger.setAttribute('aria-expanded', 'false'); }

    item.addEventListener('mouseenter', function () { clearTimeout(closeTimer); openTimer = setTimeout(open, 60); });
    item.addEventListener('mouseleave', function () { clearTimeout(openTimer); closeTimer = setTimeout(close, 160); });
    if (trigger) {
      trigger.addEventListener('focus', open);
      trigger.addEventListener('click', function (e) { e.preventDefault(); clearTimeout(openTimer); clearTimeout(closeTimer); item.classList.contains('is-open') ? close() : open(); });
    }
    item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && item.classList.contains('is-open')) { close(); if (trigger) trigger.focus(); } });
    document.addEventListener('click', function (e) { if (item.classList.contains('is-open') && !item.contains(e.target)) close(); });

    var rails = mega.querySelectorAll('[data-mm-rail]');
    var panels = mega.querySelectorAll('[data-mm-panel]');

    function activate(idx) {
      rails.forEach(function (r) {
        var on = r.getAttribute('data-mm-rail') === String(idx);
        r.setAttribute('aria-selected', on ? 'true' : 'false');
        if (r.parentElement) r.parentElement.classList.toggle('is-active', on);
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-mm-panel') === String(idx);
        p.classList.toggle('is-active', on);
        p.hidden = !on;
      });
    }

    rails.forEach(function (r) {
      var idx = r.getAttribute('data-mm-rail');
      r.addEventListener('mouseenter', function () { clearTimeout(railTimer); railTimer = setTimeout(function () { activate(idx); }, 90); });
      r.addEventListener('focus', function () { activate(idx); });
      r.addEventListener('click', function () {
        var sel = '[data-mm-panel="' + idx + '"] ';
        var link = mega.querySelector(sel + '.mm-cols__title, ' + sel + '.mm-products__seeall');
        if (link) window.location.href = link.getAttribute('href');
      });
    });
  }

  // ---- Mobile drawer (exposed so ready() can call it) ----
  window.mmInitDrawer = function () {
    var drawer = document.querySelector('[data-mm-drawer]');
    var openBtn = document.querySelector('[data-mm-drawer-open]');
    if (!drawer || !openBtn) return;
    var levels = drawer.querySelectorAll('[data-mm-level]');

    function show(name) {
      levels.forEach(function (l) {
        var on = l.getAttribute('data-mm-level') === name;
        l.classList.toggle('is-active', on);
        l.hidden = !on;
      });
    }
    function openDrawer() {
      drawer.hidden = false; document.body.style.overflow = 'hidden';
      openBtn.setAttribute('aria-expanded', 'true'); show('root');
      var closeBtn = drawer.querySelector('[data-mm-drawer-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeDrawer() {
      drawer.hidden = true; document.body.style.overflow = '';
      openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus();
    }

    openBtn.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-mm-drawer-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    drawer.querySelectorAll('[data-mm-into]').forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-mm-into')); }); });
    drawer.querySelectorAll('[data-mm-back]').forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-mm-back')); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });
  };

  function boot() {
    initAnnounce();
    initSticky();
    initDropdowns();
    initMega();
    if (window.mmInitDrawer) window.mmInitDrawer();
  }

  ready(boot);

  // Theme editor re-renders the section; re-init on load. Stale document/window
  // listeners from a prior init are harmless no-ops on detached nodes.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('[data-mm-header]')) boot();
  });
})();
